import type { SearchParameters } from 'lib-search-types';
import { Sentry } from 'lib-shared-sentry';
import { Middleware } from 'redux';

import { searchActions } from 'app/views/layout/views/search/search.actions';
import { AppState, history } from 'bootstrap.store';

import { createSearchUrl } from './utils/url/createSearchUrl';

export const searchMiddleware =
  (): Middleware<unknown, AppState> => (store) => {
    const persistParamsToURL = (
      newParams: Partial<SearchParameters<'conversations'>>,
    ) => {
      const state = store.getState();

      const params = {
        ...state.search.params,
        ...newParams,
      };

      const currQueryString = history.location.search.substring(1); // Remove the leading '?'
      const nextQueryString =
        createSearchUrl(params as SearchParameters<'conversations'>).split(
          '?',
        )[1] ?? '';

      // Only update the URL if the query string has changed.
      if (nextQueryString !== currQueryString) {
        history.push(`${history.location.pathname}?${nextQueryString}`);
      }
    };

    return (next) => (action) => {
      try {
        switch (action.type) {
          case searchActions.params.update.type: {
            const { payload } = action as ReturnType<
              typeof searchActions.params.update
            >;
            persistParamsToURL(payload);
            break;
          }

          case searchActions.savedSearch.apply.type: {
            const { payload } = action as ReturnType<
              typeof searchActions.savedSearch.apply
            >;
            persistParamsToURL(payload.searchRequest);
            break;
          }
        }
      } catch (exception) {
        Sentry.captureException(
          new Error('Search: middleware exception caught'),
          { extra: { exception } },
        );
      }

      return next(action);
    };
  };
